export default {
  eyebrow: 'Partner portal',
  title: 'Service fee calculator',
  description: 'Estimate the service fee revenue generated across the restaurants under your partner account.',
  toasts: {
    load_error: 'Could not load your service fee settings.',
  },
};
